import React, { useEffect, useState } from 'react';

import BottomSheet from '@bharatpe/bharat-ui/web/BottomSheet';
import SMS from 'assets/icons/Autopay/Chats.svg';
import MOBILE from 'assets/icons/Autopay/DeviceMobile.svg';
import { CheckCircle } from '@bharatpe/bharat-ui/web/Icons';
import Icon from '@bharatpe/bharat-ui/web/Icon';
import { Button, Typography } from '@bharatpe/bharat-ui';
import { logAnalyticsEvent } from 'utils/AnalyticsEvent';
import { useLanguageConfig } from 'Slices/LanguageConfigSlice';

interface IProps {
	handleModalClose: (...args: any[]) => void;
	handleClick: (...args: any[]) => void;
	btnText: string;
}

const PermissionModal: React.FC<IProps> = ({ handleModalClose, handleClick, btnText }) => {
	const [showModal, setShowModal] = useState(false);
	const { languageData } = useLanguageConfig();

	useEffect(() => {
		logAnalyticsEvent({
			trigger_point: `Modal View`,
			Product: 'AutoPayUPI',
			Flow: 'SetupUPI',
			Screen: 'Setup',
			Module: 'Permission_Modal',
			Action: 'Viewed',
		});
		setShowModal(true);
	}, []);

	return (
		<BottomSheet
			visible={showModal}
			showCloseButton={false}
			onClose={handleModalClose}
			heading={languageData.NEED_PERMISSION}
			rounded>
			<div className="p4">
				<div className="sm-mb8">
					<Typography variant="Light200" className="grey" component="span">
						{languageData.SO_YOU_CAN_HAVE_SMOOTH_UPI_AUTOPAY_SETUP_PROCESS_WITHOUT_ANY_HICCUPS}
					</Typography>
				</div>
				<div className="flex flex-row mb4">
					<img src={SMS} className=" mr2" />
					<div className="flex flex-column">
						<Typography variant="Bold100" className="grey" component="span">
							{languageData.SMS_PERMISSION}
						</Typography>
						<Typography variant="Light100" className="grey" component="span">
							{languageData.TO_AUTO_SEND_SMS_FOR_SETTING_UP_YOUR_UPI}
						</Typography>
					</div>
				</div>
				<div className="flex flex-row mb5">
					<img src={MOBILE} className="mr2" />
					<div className="flex flex-column">
						<Typography variant="Bold100" className="grey" component="span">
							{languageData.PHONE_PERMISSION}
						</Typography>
						<Typography variant="Light100" className="grey" component="span">
							{languageData.TO_ACTIVATE_UPI_ON_YOUR_REGISTERED_NUMBER}
						</Typography>
					</div>
				</div>
				<div className="flex content-center">
					<Icon icon={CheckCircle} className="mr2" width={'16px'} height={'16px'} color={'success'} />
					<Typography variant="Light100" className="success" component="span">
						{languageData.HUNDRED_PERCENT_SAFE_AND_SECURE}
					</Typography>
				</div>
				<Button size="large" className="mt5 width-100" disabled={false} onClick={handleClick}>
					{btnText}
				</Button>
			</div>
		</BottomSheet>
	);
};

export default PermissionModal;
